import React, { Component } from "react";
import { connect } from "react-redux";
import Axios from "axios";
import "./style.css";
import { configuration } from "../appConfig";

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class CarDentLogTable extends Component {
  state = {
    data: {},
    words: {},
    lang: "En",
  };

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({
        words: res.data,
        lang: localStorage.getItem("lang"),
      });
    });
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    //alert(nextProps.lang+"123")
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }
  componentDidMount() {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    Axios.get(
      `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
    ).then((r) => {
      if (r.data) {
        this.setState({ data: r.data });
        //console.table(r.data.Dents[0].DentPos);
        // console.table(r.data.Dents[0]);
      }
    });
    this.getLang();
  }
  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };
  render() {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const { data } = this.state;
    return (
      <div className="container p-0">
        <div className="row p-0 text-muted hide-report">
          <div className="table-responsive col p-0">
            <table className="table table-bordered table-striped dent-table-2d table-responsive w-100">
              <thead>
                <tr className="w-100">
                  <th style={{ textAlign: "center", width: "40%" }}>
                    {/* Part */}
                    {this.lang("DamageDescription")}
                    </th>
                  <th style={{ textAlign: "center", width: "10%" }}>
                    {this.lang("Added Count")}
                  </th>
                  <th style={{ textAlign: "center", width: "10%" }}>
                    {this.lang("Removed Count")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.Dents &&
                  data.Dents.length &&
                  data.Dents.map((r, i) => (
                    <tr key={i}>
                      <td style={{ textAlign: "left" }}>{this.lang(r.Part)}</td>
                      <td style={{}}>{r.AddedCount}</td>
                      <td style={{}}>{r.RemovedCount}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps)(CarDentLogTable);
